import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import { type QueryIntent } from '../constants';
import { filterCommonAttributes } from './analytics-helpers';
import type { commonAttributesType } from './types';

// When query intent detection api classifies intent, routes the ui position of a smart answer
export const onSmartAnswerRouteDetection: (
	props: commonAttributesType,
	smartAnswersRoute: QueryIntent,
) => AnalyticsEventPayload = (
	props: commonAttributesType,
	smartAnswersRoute: QueryIntent,
): AnalyticsEventPayload => {
	const { query, source } = props;
	return {
		action: 'classified',
		actionSubject: 'aiAnswerRoute',
		source: source,
		eventType: 'track',
		attributes: {
			...filterCommonAttributes(props),
			smartAnswersRoute: smartAnswersRoute,
		},
		nonPrivacySafeAttributes: {
			query,
		},
	};
};
